// extracted by mini-css-extract-plugin
export default {"page":"DeviceDetailsPage_page__rZT4e","breadcrumb":"DeviceDetailsPage_breadcrumb__Hylya","card":"DeviceDetailsPage_card__d6GNd"};